export default __webpack_public_path__ + "static/media/website-logo-white.9840a13b.svg";